// LIBRARIES //
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FlatButton from 'material-ui/FlatButton';
import React from 'react';
import styled from 'styled-components';

// COMPONENTS //
import { GoogleReviewDialogContent } from 'components/landlord_app/properties/components/GoogleReview/GoogleReviewDialogueForm.js';

// HELPERS //
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';

const StyledDialogTitle = styled(DialogTitle)`
  padding: 24px;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledTitle = styled.h3`
  margin: 0px;
  font-size: 24px;
  font-family: 'Circular-Bold';
  font-weight: bold;
  color: #333333;
`;

const StyledSecondaryFlatButton = styled(FlatButton)`
  color: ${AccentColor()} !important;
  background-color: #fff !important;
  border: solid 1px ${AccentColor()} !important;
  float: right;
  margin-right: 24px !important;
`;

export const GoogleReviewForm = ({
  values,
  handleChange,
  setFieldValue,
  submitForm,
  handleClose,
  isSubmitting,
  setGoogleReviewRating,
  disableConfirmation,
  minimumLandlordRating,
  errors,
  handleDisableConfirmation,
  touched,
  googleReviewActive,
}) => {
  const setRatingAndFieldValue = value => {
    setFieldValue('google_reviews_minimum_rating', value, true);
    setGoogleReviewRating(value);
  };

  return (
    <StyledForm>
      <StyledDialogTitle>
        <StyledTitle>
          {getTranslatedString(`landlordPortal.properties.googleReviewsDialog.title`)}
        </StyledTitle>
      </StyledDialogTitle>
      <DialogContent>
        <GoogleReviewDialogContent
          disableConfirmation={disableConfirmation}
          handleChange={handleChange}
          values={values}
          setRatingValue={setRatingAndFieldValue}
          minimumLandlordRating={minimumLandlordRating}
          errors={errors}
          touched={touched}
        />
      </DialogContent>
      <DialogActions
        style={{
          display: 'initial',
          justifyContent: 'inherit',
          marginRight: '24px',
          marginLeft: '24px',
          marginBottom: '24px',
        }}
      >
        <FormButtons
          handleClose={handleClose}
          submitForm={submitForm}
          isSubmitting={isSubmitting}
          disableConfirmation={disableConfirmation}
          handleDisableConfirmation={handleDisableConfirmation}
          googleReviewActive={googleReviewActive}
        />
      </DialogActions>
    </StyledForm>
  );
};

const FormButtons = ({
  handleDisableConfirmation,
  disableConfirmation,
  handleClose,
  submitForm,
  isSubmitting,
  googleReviewActive,
}) => (
  <React.Fragment>
    <FlatButton
      onClick={disableConfirmation ? handleDisableConfirmation : handleClose}
      id="close-button"
      style={{ color: AccentColor() }}
    >
      {getTranslatedString(disableConfirmation ? 'cancel' : 'close')}
    </FlatButton>
    <FlatButton
      onClick={() => submitForm()}
      id="submit-button"
      style={{
        color: 'white',
        backgroundColor: isSubmitting ? colors.LIGHT_GRAY : AccentColor(),
        float: 'right',
      }}
    >
      {getTranslatedString(
        googleReviewActive ? 'save' : 'landlordPortal.properties.googleReviewsDialog.enable'
      )}
    </FlatButton>
    <DisableFormButton
      handleDisableConfirmation={handleDisableConfirmation}
      googleReviewActive={googleReviewActive}
      disableConfirmation={disableConfirmation}
    />
  </React.Fragment>
);

const DisableFormButton = ({
  handleDisableConfirmation,
  googleReviewActive,
  disableConfirmation,
}) => {
  if (!googleReviewActive) return null;
  if (disableConfirmation) return null;

  return (
    <StyledSecondaryFlatButton onClick={() => handleDisableConfirmation()}>
      {getTranslatedString(`landlordPortal.properties.googleReviewsDialog.disable`)}
    </StyledSecondaryFlatButton>
  );
};
